import React from 'react';
import Page from "../Components/Page";
import {ExtendTimeService} from "../Components/ExtendTimeService";

const AdminPage = () => {
    return (
        <Page name={"Admin"}>
            <ol>
                <li key={'last-production-deployment'}>
                    <a href={`/lastProductionDeployment`} target="_blank" rel="noopener noreferrer">Last Production Deployment</a>
                </li>
                <li key={'alert-id-mapping'}>
                    <a href={`/alertIdMapping`} target="_blank" rel="noopener noreferrer">Alert Id Mapping</a>
                </li>
                <li key={'incoming-bucket-details-mapping'}>
                    <a href={`/incomingBucketDetails`} target="_blank" rel="noopener noreferrer">Incoming Bucket Details</a>
                </li>
                <li key={'ftp-to-data-provider-id-decode'}>
                    <a href={`/ftpToDataProviderIdDecode`} target="_blank" rel="noopener noreferrer">FTP To Data Provider Id Decode</a>
                </li>
                <li key={'period-release-audit-changes'}>
                    <a href={`/periodReleaseAuditChanges`} target="_blank" rel="noopener noreferrer">Period Release Audit Changes</a>
                </li>
                <li key={'period-release-checkpoints'}>
                    <a href={`/periodReleaseCheckpoints`} target="_blank" rel="noopener noreferrer">Period Release Checkpoints</a>
                </li>
                <li key={'cloud-costs'}>
                    <a href={`/cloudCosts`} target="_blank" rel="noopener noreferrer">Cloud Costs</a>
                </li>
                <li key={'system'}>
                    <a href={`/system`} target="_blank" rel="noopener noreferrer">System</a>
                </li>
                <li key={'extend-time-service'}>
                    <ExtendTimeService/>
                </li>
            </ol>
        </Page>
    );
};

export default AdminPage;